import { SiGitconnected } from "react-icons/si";
import { onModuleContent } from "../_Resources/Content/Module.Resources";
import { AuthLoginViewMain } from "../Components/Login/AuthLoginViewMain";

export const AuthModule = (DATA_USER_AUTH = null, lang = "es") => {

    const RESOURCES = onModuleContent(lang);

    return [
        {
            views: "PUBLIC", path: "/login", component: <AuthLoginViewMain />,
            roles: null, permissions: null, label: RESOURCES.LABEL, icon: <SiGitconnected />,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: true,
        },
    ];
};
